<template>
  <div class="adv">
    <!-- <img :src="adimg" class="image" @click="url" /> -->
    <el-carousel
      trigger="click"
      class="carousel"
      indicator-position="none"
      arrow="never"
      height="88px"
      :interval="5000"
    >
      <el-carousel-item v-for="(item, index) in advs" :key="index">
        <el-image
          :src="item.adimg"
          fit="fill"
          class="image"
          @click="url(item.adlink)"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
    <div @click="close" class="close"><i class="el-icon-close"></i>广告</div>
  </div>
</template>
  <script>
export default {
  props: {
    advs: {
      type: Array,
    },
  },
  data() {
    return {
      number: "",
    };
  },
  created() {
    // this.random()
  },
  methods: {
    close() {
      this.$emit("closeAdv");
    },
    // random(){
    //     this.number =  Math.floor(Math.random()*3);
    //     console.log(this.number)
    // },
    url(e) {
      console.log(e);
      window.location.href = decodeURIComponent(e);
    },
  },
};
</script>
  <style scoped>
.adv {
  width: 100%;
  height: 90px;
  position: fixed;
  bottom: 0px;
  background-color: white;
  border: 1px solid #e6e7e8;
  box-sizing: border-box;
  border-radius: 2px;
}
.carousel {
  width: 100%;
  height: 88px;
  /* object-fit: contain; */
}
.close {
  width: 60px;
  height: 14px;
  position: absolute;
  left: 0px;
  bottom: 0px;
  color: #00aecd;
  font-size: 12px;
  line-height: 14px;
  z-index: 999;
}
.image {
  width: 100%;
  height: 88px;
}
.close i {
  font-size: 14px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/adv.vue